export const WORK_TONES = ["pink", "stone", "sand", "sage"] as const;

export type WorkTone = (typeof WORK_TONES)[number];

export const toneForWorkId = (workId: number): WorkTone => WORK_TONES[workId % WORK_TONES.length];

export const initialForWorkName = (name: string): string => {
    const trimmed = name.trim();
    return trimmed ? trimmed.charAt(0).toUpperCase() : "?";
};
